import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Container, 
  Box, 
  Menu, 
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import BalanceIcon from '@mui/icons-material/Balance'; // Import scales of justice icon

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState(false);
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleMobileDrawer = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  const toggleMobileSubmenu = () => {
    setMobileSubmenuOpen(!mobileSubmenuOpen);
  };

  const handleMobileMenuClick = () => {
    setMobileDrawerOpen(false);
  };

  const mobileNavItems = [
    { text: 'Home', link: '/' },
    { text: 'Services', link: '/services' },
    { text: 'About', link: '/about' },
    { text: 'GST Calculator', link: '/calculator' },
    { text: 'Contact', link: '/contact' }
  ];

  const mobileSubmenuItems = [
    { text: 'Court Notices and Order', link: '/notices' },
    { text: 'GST Updates', link: '/gstupdate' }
  ];

  return (
    <>
      <AppBar position="static" sx={{ bgcolor: 'primary.main', boxShadow: 'none' }}>
        <Container>
          <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', padding: '1rem 0' }}>
            <Box 
              component={Link} 
              to="/" 
              sx={{ 
                textDecoration: 'none', 
                color: 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5
              }}
            >
              <BalanceIcon 
                sx={{ 
                  fontSize: { xs: '2.2rem', sm: '2.5rem' },
                  color: 'white' 
                }} 
              />
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 'bold',
                  fontFamily: 'Roboto, sans-serif',
                  letterSpacing: '0.05em',
                  fontSize: { xs: '1.4rem', sm: '1.7rem' }
                }}
              >
                Legalistic & Associates
              </Typography>
            </Box>

            {isMobile ? (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={toggleMobileDrawer}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <Box sx={{ display: 'flex', gap: 3 }}>
                <Button color="inherit" component={Link} to="/" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Home</Button>
                <Button color="inherit" component={Link} to="/services" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Services</Button>
                <Button color="inherit" component={Link} to="/about" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>About</Button>
                <Button color="inherit" component={Link} to="/contact" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Contact</Button>
                <Button
                  color="inherit"
                  onClick={handleMenuOpen}
                  sx={{ fontWeight: 'bold', fontSize: '1rem' }}
                >
                  Notices and Updates
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  sx={{ mt: 1 }}
                >
                  <MenuItem component={Link} to="/notices" onClick={handleMenuClose} sx={{ fontSize: '0.9rem' }}>Court Notices and Order</MenuItem>
                  <MenuItem component={Link} to="/gstupdate" onClick={handleMenuClose} sx={{ fontSize: '0.9rem' }}>GST Updates</MenuItem>
                </Menu>
                <Button color="inherit" component={Link} to="/calculator" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>GST Calculator</Button>
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Navigation Drawer */}
      <Drawer
        anchor="right"
        open={mobileDrawerOpen}
        onClose={toggleMobileDrawer}
        PaperProps={{
          sx: { width: { xs: '80%', sm: '60%', md: '40%' }, p: 2 }
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Menu</Typography>
          <IconButton onClick={toggleMobileDrawer}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <List>
          {mobileNavItems.map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton 
                component={Link} 
                to={item.link}
                onClick={handleMobileMenuClick}
                sx={{ py: 1.5 }}
              >
                <ListItemText 
                  primary={item.text} 
                  primaryTypographyProps={{ 
                    fontWeight: 'medium',
                    fontSize: '1rem'
                  }} 
                />
              </ListItemButton>
            </ListItem>
          ))}
          
          {/* Submenu for notices and updates */}
          <ListItem disablePadding>
            <ListItemButton onClick={toggleMobileSubmenu} sx={{ py: 1.5 }}>
              <ListItemText 
                primary="Notices and Updates" 
                primaryTypographyProps={{ 
                  fontWeight: 'medium',
                  fontSize: '1rem'
                }} 
              />
            </ListItemButton>
          </ListItem>
          
          {mobileSubmenuOpen && (
            <Box sx={{ pl: 2 }}>
              {mobileSubmenuItems.map((item) => (
                <ListItem key={item.text} disablePadding>
                  <ListItemButton 
                    component={Link} 
                    to={item.link}
                    onClick={handleMobileMenuClick}
                    sx={{ py: 1.25 }}
                  >
                    <ListItemText 
                      primary={item.text} 
                      primaryTypographyProps={{ 
                        fontSize: '0.95rem'
                      }} 
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </Box>
          )}
        </List>
      </Drawer>

     
    </>
  );
};

export default Header;